export type IntegrationCatalogCategory = 'scheduling' | 'meetings' | 'crm';

export interface IntegrationCatalogItem {
  id: string;
  label: string;
  description: string;
  category: IntegrationCatalogCategory;
  promptHint: string;
  /** Optional brand icon under assets/images/integrations/ */
  iconSrc?: string;
}

export const INTEGRATION_CATALOG: IntegrationCatalogItem[] = [
  {
    id: 'google-calendar',
    label: 'Google Calendar',
    description: 'Let respondents book time on a Google Calendar.',
    category: 'scheduling',
    promptHint: 'Add a Google Calendar booking integration',
    iconSrc: 'assets/images/integrations/google-calendar.svg',
  },
  {
    id: 'calendly',
    label: 'Calendly',
    description: 'Embed Calendly scheduling links in the form flow.',
    category: 'scheduling',
    promptHint: 'Add a Calendly scheduling integration',
    iconSrc: 'assets/images/integrations/calendly.svg',
  },
  {
    id: 'zoho-bookings',
    label: 'Zoho Bookings',
    description: 'Collect appointments through Zoho Bookings.',
    category: 'scheduling',
    promptHint: 'Add a Zoho Bookings scheduling integration',
    iconSrc: 'assets/images/integrations/zoho-bookings.svg',
  },
  {
    id: 'google-meet',
    label: 'Google Meet',
    description: 'Generate a Google Meet link with the submission.',
    category: 'meetings',
    promptHint: 'Add a Google Meet meeting integration',
    iconSrc: 'assets/images/integrations/google-meet.svg',
  },
  {
    id: 'zoom',
    label: 'Zoom',
    description: 'Create or attach a Zoom meeting for the response.',
    category: 'meetings',
    promptHint: 'Add a Zoom meeting integration',
    iconSrc: 'assets/images/integrations/zoom.svg',
  },
  {
    id: 'microsoft-teams',
    label: 'Microsoft Teams',
    description: 'Schedule a Teams meeting from the form.',
    category: 'meetings',
    promptHint: 'Add a Microsoft Teams meeting integration',
    iconSrc: 'assets/images/integrations/microsoft-teams.svg',
  },
  {
    id: 'hubspot',
    label: 'HubSpot',
    description: 'Sync submissions into HubSpot contacts and deals.',
    category: 'crm',
    promptHint: 'Add a HubSpot CRM integration',
    iconSrc: 'assets/images/integrations/hubspot.svg',
  },
  {
    id: 'salesforce',
    label: 'Salesforce',
    description: 'Push leads and form data into Salesforce.',
    category: 'crm',
    promptHint: 'Add a Salesforce CRM integration',
    iconSrc: 'assets/images/integrations/salesforce.svg',
  },
  {
    id: 'slack',
    label: 'Slack',
    description: 'Notify a Slack channel when a form is submitted.',
    category: 'crm',
    promptHint: 'Add a Slack notification integration',
    iconSrc: 'assets/images/integrations/slack.svg',
  },
];

export const SCHEDULING_INTEGRATIONS = INTEGRATION_CATALOG.filter(
  (item) => item.category === 'scheduling',
);
export const MEETING_INTEGRATIONS = INTEGRATION_CATALOG.filter(
  (item) => item.category === 'meetings',
);
export const CRM_INTEGRATIONS = INTEGRATION_CATALOG.filter((item) => item.category === 'crm');
